import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BankTransactionQueryParams,
  BankTransactionQueryResult
} from './bank.model';
import { GetFileInputData, ResourceService } from 'common';
import { AppSettings } from '../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class BankTransactionsService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    private resourceService: ResourceService,
    private settings: AppSettings
  ) {
    this.baseUrl = `${this.settings.entities.url}`;
  }

  queryBankTransactions(
    entityId: number,
    bankAccountId: number,
    params: BankTransactionQueryParams): Observable<BankTransactionQueryResult> {

    const url = `${this.baseUrl}/api/bank-transactions/${entityId}/account/${bankAccountId}/transaction/list`;
    return this.http.get<BankTransactionQueryResult>(url, { params: <any>params });
  }

  downloadBankTransactions(entityId: number, bankAccountId: number, params: any): void {
    const url = `${this.baseUrl}/api/bank-transactions/${entityId}/account/${bankAccountId}/transaction/csv`;
    const inputData: GetFileInputData = { url, filename: "bank-transactions.csv", params };
    this.resourceService.download(inputData).subscribe();
  }
}
